import RouteCheckerTo from '@/views/route-checker';
import DaisyMessageView from './daisy-message.view.vue';

export default [
  {
    path: '/daisy-messages',
    name: 'Mensagens da Daisy',
    component: DaisyMessageView,
    beforeEnter: RouteCheckerTo.hasAccessDaisyMessage,
  },
];
